import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit05 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.16667 3.33332H5.66667C4.26654 3.33332 3.56647 3.33332 3.0317 3.6058C2.56129 3.84549 2.17884 4.22794 1.93916 4.69834C1.66667 5.23312 1.66667 5.93319 1.66667 7.33332V14.3333C1.66667 15.7335 1.66667 16.4335 1.93916 16.9683C2.17884 17.4387 2.56129 17.8212 3.0317 18.0608C3.56647 18.3333 4.26654 18.3333 5.66667 18.3333H12.6667C14.0668 18.3333 14.7669 18.3333 15.3016 18.0608C15.7721 17.8212 16.1545 17.4387 16.3942 16.9683C16.6667 16.4335 16.6667 15.7335 16.6667 14.3333V10.8333M6.66665 13.3333H8.0621C8.46975 13.3333 8.67358 13.3333 8.86539 13.2873C9.03545 13.2464 9.19803 13.1791 9.34715 13.0877C9.51534 12.9847 9.65947 12.8405 9.94772 12.5523L17.9167 4.58332C18.607 3.89296 18.607 2.77368 17.9167 2.08332C17.2263 1.39296 16.107 1.39296 15.4167 2.08332L7.4477 10.0523C7.15945 10.3405 7.01532 10.4847 6.91225 10.6528C6.82087 10.802 6.75353 10.9645 6.7127 11.1346C6.66665 11.3264 6.66665 11.5302 6.66665 11.9379V13.3333Z",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEdit05;
